import { Typography } from '@mui/material';
import { HttpError } from 'react-admin';

export const HttpErrorTypography = ({ error }: { error: HttpError | null }) => {
  return (
    <Typography
      variant='body2'
      color='error'
      sx={{
        whiteSpace: 'pre-wrap', // preserve newlines but allow wrapping
        wordBreak: 'break-word', // break long words/tokens
        overflowWrap: 'anywhere',
        margin: 0, // keep <pre> compact inside modal
        width: '100%',
      }}>
      {error?.message}
    </Typography>
  );
};
